import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { KeplerMatchList } from '../../kepler/models/KeplerMatch';
import { KeplerService } from 'app/kepler/services/kepler.service';
import { Client } from 'core/models/client';

@Component({
  selector: 'lms-client-kepler-detail',
  templateUrl: './client-kepler-detail.component.html',
  styleUrls: ['./client-kepler-detail.component.scss']
})
export class ClientKeplerDetailComponent implements OnInit {
  @Input() client: Client;
  public toolbarConfig: any;
  public clientKeplerMatchListId = 'CLIENT_KEPLER_MATCH_LIST';
  public matchKeplerList: KeplerMatchList;
  public isNewKeplerMatch: boolean = false;

  constructor(private route: ActivatedRoute, private router: Router, private keplerService: KeplerService) {}

  public ngOnInit(): void {
    this.toolbarConfig = {
      list: {
        listId: this.clientKeplerMatchListId,
        download: true,
        filterRow: true,
        columnChooser: true,
        skeletor: true
      }
    };
    this.keplerService.fetch({ clientId: this.client.id }).then((data) => {
      this.matchKeplerList = data ? data : { docs: [] };
    });
  }

  public goEditorKepler(): void {
    this.isNewKeplerMatch = true;
  }

  public saveMatch(event): void {
    this.router.navigate(['/clients', this.client.id, 'kepler', event.id]).then(() => (this.isNewKeplerMatch = false));
  }

  public goKeplerList(): void {
    this.router
      .navigate(['/clients', this.client.id], { fragment: 'kepler' })
      .then(() => (this.isNewKeplerMatch = false));
  }
}
